import { render } from "./SearchDropdown.vue?vue&type=template&id=10ecac1e"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__